(function () {
  var FALLBACK_ANON_KEY = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJpc3MiOiJzdXBhYmFzZSIsInJlZiI6Inhwamp2cmpjam91eWxhcnR1cHd5Iiwicm9sZSI6ImFub24iLCJpYXQiOjE3NDk3MzQ3MTEsImV4cCI6MjA2NTMxMDcxMX0.OYbFjEfyO4IspmLKW8W9yqre-46GiqobE22yO7aUvLM';
  var SUPABASE_URL = 'https://xpjjvrjcjouylartupwy.supabase.co';

  function readMeta(name) {
    var el = document.querySelector('meta[name="' + name + '"]');
    return el ? el.getAttribute('content') || '' : '';
  }

  function setMessage(form, text, isError) {
    var msg = form.querySelector('[data-be-form-message]');
    if (!msg) return;
    msg.textContent = text;
    msg.classList.add('is-visible');
    msg.classList.toggle('is-error', !!isError);
  }

  var CONTACT_GUIDES = {
    pastry: {
      href: '/pages/wholesale-pastry',
      label: 'Wholesale pastry',
      note: 'Wholesale pastry has its own page. Look there first, then send a message below if you still need to.',
    },
    coffee: {
      href: '/pages/wholesale-coffee',
      label: 'Wholesale coffee',
      note: 'Wholesale coffee has its own page. Look there first, then send a message below if you still need to.',
    },
    jobs: {
      href: '/pages/careers-application',
      label: 'Start your application',
      note: 'Jobs start with the application. Look there first, then send a message below if you still need to.',
    },
    donation: {
      href: '/pages/donation-request',
      label: 'Request a donation',
      note: 'Donation requests have their own form. Look there first, then send a message below if you still need to.',
    },
    event: {
      href: '/pages/catering',
      label: 'Catering',
      note: 'Events and catering have their own page. Look there first, then send a message below if you still need to.',
    },
  };

  function applyContactReason(form) {
    var reason = form.querySelector('[name="reason"]');
    var fields = form.querySelector('[data-be-contact-message-fields]');
    var redirect = form.querySelector('[data-be-contact-redirect]');
    if (!reason || !fields) return;
    var route = CONTACT_GUIDES[reason.value] || null;
    var showMessage = !!reason.value;
    fields.hidden = !showMessage;
    fields.disabled = !showMessage;
    if (!redirect) return;
    if (!route) {
      redirect.hidden = true;
      return;
    }
    redirect.hidden = false;
    var note = redirect.querySelector('[data-be-contact-redirect-note]');
    var link = redirect.querySelector('[data-be-contact-redirect-link]');
    if (note) note.textContent = route.note;
    if (link) {
      link.href = route.href;
      link.textContent = route.label;
    }
  }

  function bindContactForms() {
    document.querySelectorAll('[data-be-contact-form]').forEach(function (form) {
      if (form.dataset.beFormBound) return;
      form.dataset.beFormBound = '1';

      var reason = form.querySelector('[name="reason"]');
      if (reason) {
        reason.addEventListener('change', function () {
          applyContactReason(form);
        });
        applyContactReason(form);
      }

      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var anon = readMeta('supabase-anon-key') || FALLBACK_ANON_KEY;
        if (!anon) {
          setMessage(form, 'Something went wrong. Please call us at (615) 912-0314.', true);
          return;
        }

        var submitBtn = form.querySelector('[type="submit"]');
        var defaultLabel = submitBtn ? submitBtn.textContent : 'Send';
        if (submitBtn) {
          submitBtn.disabled = true;
          submitBtn.textContent = 'Sending…';
        }

        var honeypot = form.querySelector('[name="website"]');
        if (honeypot && honeypot.value) {
          setMessage(form, 'Thanks — we received your message.', false);
          if (submitBtn) {
            submitBtn.disabled = false;
            submitBtn.textContent = defaultLabel;
          }
          return;
        }

        var reasonEl = form.querySelector('[name="reason"]');
        var reasonValue = reasonEl ? reasonEl.value : '';

        var payload = {
          name: (form.querySelector('[name="name"]') || {}).value || '',
          email: (form.querySelector('[name="email"]') || {}).value || '',
          phone: (form.querySelector('[name="phone"]') || {}).value || '',
          subject: (form.querySelector('[name="subject"]') || {}).value || form.getAttribute('data-be-form-topic') || '',
          message: (form.querySelector('[name="message"]') || {}).value || '',
          reason: reasonValue,
          website: honeypot ? honeypot.value : '',
        };

        var rentalType = (form.querySelector('[name="rental_type"]') || {}).value || '';
        var eventDate = (form.querySelector('[name="event_date"]') || {}).value || '';
        var guests = (form.querySelector('[name="guests"]') || {}).value || '';
        if (rentalType || eventDate || guests) {
          var extras = [];
          if (rentalType) extras.push('Rental type: ' + rentalType);
          if (eventDate) extras.push('Preferred date: ' + eventDate);
          if (guests) extras.push('Guests: ' + guests);
          payload.message = (payload.message ? payload.message + '\n\n' : '') + extras.join('\n');
        }
        if (!payload.subject) {
          payload.subject = payload.name ? 'Message from ' + payload.name : 'Website contact form';
        }

        fetch(SUPABASE_URL + '/functions/v1/shopify-contact-form', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Authorization: 'Bearer ' + anon,
            apikey: anon,
          },
          body: JSON.stringify(payload),
        })
          .then(function (r) {
            return r.json().then(function (j) {
              return { ok: r.ok, j: j };
            });
          })
          .then(function (res) {
            if (!res.ok || res.j.error) {
              throw new Error(res.j.error || 'Request failed');
            }
            form.reset();
            setMessage(form, 'Thanks — we received your message and will reply soon.', false);
          })
          .catch(function () {
            setMessage(form, 'Could not send right now. Email us or call (615) 912-0314.', true);
          })
          .finally(function () {
            if (submitBtn) {
              submitBtn.disabled = false;
              submitBtn.textContent = defaultLabel;
            }
          });
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function () {
    bindContactForms();
    document.querySelectorAll('.be-page a[href^="#"]').forEach(function (anchor) {
      anchor.addEventListener('click', function (e) {
        var id = this.getAttribute('href').slice(1);
        var el = id ? document.getElementById(id) : null;
        if (el) {
          e.preventDefault();
          el.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    });
  });
})();
